import { useContext } from 'react';
import { createContext } from 'react';
import useResponsiveValues from '../../../responsive-values/useResponsiveValues';
import { FlexColProps } from '../@types/FlexLayoutProps';

export const FlexColContext = createContext<FlexColProps>({} as FlexColProps);

FlexColContext.displayName = 'FlexCol';

export function FlexColProvider(props: FlexColProps) {
	const value = useResponsiveValues(props);
	return <FlexColContext.Provider value={value}>{props.children}</FlexColContext.Provider>;
}

export function useFlexCol() {
	const context = useContext(FlexColContext);

	return context;
}
